import React, { useEffect } from 'react';
import { initMetaPixel } from './lib/metaPixel';
import { ErrorBoundary } from './components/ErrorBoundary';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Timeline } from './components/Timeline';
import { Comparison } from './components/Comparison';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseNotifications } from './components/PurchaseNotifications';
export function App() {
  useEffect(() => {
    // Defer to next tick so analytics never blocks initial paint.
    const t = setTimeout(() => {
      initMetaPixel();
    }, 0);
    return () => clearTimeout(t);
  }, []);
  return <div className="min-h-screen w-full max-w-full overflow-x-hidden bg-charcoal text-ivory selection:bg-teal selection:text-ivory" data-id="element-0">
      <ErrorBoundary data-id="element-1">
        <Header data-id="element-2" />
      </ErrorBoundary>
      <main data-id="element-3">
        <ErrorBoundary data-id="element-4">
          <Hero data-id="element-5" />
        </ErrorBoundary>
        <ErrorBoundary data-id="element-6">
          <Timeline data-id="element-7" />
        </ErrorBoundary>
        <ErrorBoundary data-id="element-8">
          <Comparison data-id="element-9" />
        </ErrorBoundary>
        <ErrorBoundary data-id="element-10">
          <Testimonials data-id="element-11" />
        </ErrorBoundary>
        <ErrorBoundary data-id="element-12">
          <FAQ data-id="element-13" />
        </ErrorBoundary>
        <ErrorBoundary data-id="element-14">
          <FinalCTA data-id="element-15" />
        </ErrorBoundary>
      </main>
      <ErrorBoundary data-id="element-16">
        <Footer data-id="element-17" />
      </ErrorBoundary>
      <ErrorBoundary data-id="element-18">
        <PurchaseNotifications data-id="element-19" />
      </ErrorBoundary>
    </div>;
}